import { fetchOrganization } from "@stryker/core/api/organization";
import { QueryKeys } from "@stryker/core/queryKeys";
import { useQuery } from "@tanstack/react-query";

export default function useOrganization() {
  return useQuery({
    queryKey: [QueryKeys.Organization],
    queryFn: fetchOrganization,
    select: (response) => {
      return { ...response, balanceValue: response.balance?.credits ?? 0 };
    },
  });
}
